import React from "react";
import "../../sass/buttons/readMore.scss";

function ReadMore() {
  return <button className="readMore">read more</button>;
}

export default ReadMore;
